// components
import { getItemFromLocalStorage } from 'components/conversations';
// constants
import { LOCAL_STORAGE_CONVERSATION } from 'const/keys';
// utils
import { getShortUrlFromUrl } from 'utils/url';

export interface IConversation {
  conversationId: string;
  userId: number;
}

export const getSingleConversationFromLocalStorage = ():
  | IConversation
  | undefined => {
  const shortUrl = getShortUrlFromUrl();
  if (!shortUrl) {
    return undefined;
  }
  return getItemFromLocalStorage<Record<string, IConversation>>(
    LOCAL_STORAGE_CONVERSATION
  )?.[shortUrl];
};

export const getAllConversationsFromLocalStorage = () => {
  return getItemFromLocalStorage<Record<string, IConversation>>(
    LOCAL_STORAGE_CONVERSATION
  );
};
